var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('span',[_vm._v(_vm._s(_vm.timeToEta))]),_c('span',{staticClass:"body-2 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("formatTime")(_vm.trip.eta)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }